"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainUrlInput = void 0;
var react_1 = __importStar(require("react"));
var validator_1 = require("validator");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./DomainUrlInput.css"));
var DomainUrlInput = function (_a) {
    var onSubmit = _a.onSubmit, dataStore = _a.dataStore;
    var inputId = (0, react_1.useRef)("domain-url-input");
    var _b = __read((0, react_1.useState)(""), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = __read((0, react_1.useState)(dataStore.websiteUrl), 2), domainUrl = _c[0], setDomainUrl = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isLoading = _d[0], setIsLoading = _d[1];
    var sanitiseUrl = function (url) {
        var arr = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/im);
        if (!arr || arr.length < 2) {
            return "";
        }
        return arr[1];
    };
    var submitHandle = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], __read(args_1), false), Promise, function (url) {
            var e_1;
            if (url === void 0) { url = ""; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(0, validator_1.isURL)(url)) {
                            setErrorMessage("Please enter a valid URL.");
                            return [2];
                        }
                        setIsLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4, onSubmit(sanitiseUrl(url))];
                    case 2:
                        _a.sent();
                        return [3, 5];
                    case 3:
                        e_1 = _a.sent();
                        return [3, 5];
                    case 4:
                        setIsLoading(false);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    var onChangeHandle = function (url) {
        setDomainUrl(url);
        setErrorMessage("");
        dataStore.setWebsiteUrl(url);
    };
    return (react_1.default.createElement(kaleidoscope_1.TextInput, { className: styles.textInput, id: inputId.current, autoFocus: true, size: kaleidoscope_1.TextInputSize.Large, labelSize: kaleidoscope_1.TextInputLabelSize.Medium, label: "Enter your domain or website URL", placeholder: "https://www.example.com", inputMode: "url", value: domainUrl, onChange: onChangeHandle, onKeyDown: function (event) { return __awaiter(void 0, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(event.key === "Enter")) return [3, 2];
                        return [4, submitHandle(domainUrl)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); }, error: errorMessage !== null && errorMessage !== void 0 ? errorMessage : undefined, endElement: react_1.default.createElement(kaleidoscope_1.Button, { buttonState: isLoading ? kaleidoscope_1.ButtonState.Waiting : kaleidoscope_1.ButtonState.Idle, "aria-labelledby": "".concat(inputId.current, "-label"), size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () { return submitHandle(domainUrl); } }, react_1.default.createElement(icons_1.ArrowRight, null)) }));
};
exports.DomainUrlInput = DomainUrlInput;
